// @ts-nocheck
import { resolveColor } from "@insite/mobius/utilities";
import { OptionProps } from "@store/MobiusOverrides/DynamicDropdown/DynamicDropdown";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusOutlineStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export const autocompleteFontStyles = () => css`
    ${({ theme }) => css`
        font-size: ${theme.design.typography.size.smaller};
        line-height: ${theme.design.typography.lineHeight.semi};
    `}
`;

export const autocompleteLinkWithImageStyles = () => css`
    display: flex;
    align-items: center;
    gap: ${pxToRem(10)};
`;

export const autocompleteOptionCommonStyles = () => {
    return css`
        ${({ theme }) => cssProp("color", theme.design.autocomplete.link.hoverColor, x => resolveColor(x, theme))}
        background: none;
    `;
};

export const autocompleteOptionStyles = () => {
    return css<OptionProps>`
        color: ${({ theme }) => resolveColor(theme.design.autocomplete.link.color, theme)};
        text-decoration: ${({ theme }) => (theme.design.autocomplete.link.underline ? "underline" : "none")};
        transition: ${transitionHoverStyles("color")};

        &:hover {
            ${autocompleteOptionCommonStyles()}
            text-decoration: ${({ theme }) => (theme.design.autocomplete.link.hoverUnderline ? "underline" : "none")};
        }

        ${({ focused, selected }) => {
            if (focused) {
                return css`
                    ${autocompleteOptionCommonStyles()}

                    &:not(:focus-visible) {
                        transition: none;
                        ${x => focusOutlineStyles(`-${x.theme.focus.width}`)}
                    }
                `;
            }

            if (selected) {
                return css`
                    ${autocompleteOptionCommonStyles()}
                    color: inherit;
                    background: inherit;
                `;
            }
        }}
    ` as any;
};
